import { isCustomDomain, getCurrentDomain } from "./domainResolver";
import { hasAnalyticsConsentAccepted } from "./analyticsConsent";
import { isGoogleAnalyticsReady } from "./googleAnalytics";
import { isMicrosoftClarityReady } from "./microsoftClarity";

let runtime = {
  sellerID: null,
  gaEnabled: false,
  clarityEnabled: false,
  scriptsReady: false,
};

export function setWebAnalyticsRuntime(partial) {
  runtime = { ...runtime, ...partial };
}

export function resetWebAnalyticsRuntime() {
  runtime = {
    sellerID: null,
    gaEnabled: false,
    clarityEnabled: false,
    scriptsReady: false,
  };
}

export function canTrackWebAnalytics() {
  try {
    if (!runtime.scriptsReady || !runtime.sellerID) return false;
    if (!isCustomDomain(getCurrentDomain())) return false;
    if (!hasAnalyticsConsentAccepted(runtime.sellerID)) return false;
    return runtime.gaEnabled || runtime.clarityEnabled;
  } catch {
    return false;
  }
}

export function canTrackGa4Events() {
  return canTrackWebAnalytics() && runtime.gaEnabled && isGoogleAnalyticsReady();
}

export function canTrackClarityEvents() {
  return canTrackWebAnalytics() && runtime.clarityEnabled && isMicrosoftClarityReady();
}
